import React from "react";
import { IBackButtonProps } from "./BackButtonComponent.interface";
import BackArrow from "assets/images/back_arrow.svg";

const BackButtonComponent = (props: IBackButtonProps) => {
  return (
    <div className="back-button">
      <a href="javascript:void(0)" onClick={props.backButtonHandler}>
        {" "}
        {/* TO-DO: Convert this to a button in all compoents. */}
        <span>
          <img src={BackArrow} alt="close" />
        </span>{" "}
        {props.backButtonText}
      </a>
    </div>
  );
};

export default BackButtonComponent;
